import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { NotificationModel } from '../models/classes/notification';

@Injectable({
  providedIn: 'root',
})
export class SignalrService {
  public data: NotificationModel;
  public hubConnection!: signalR.HubConnection;

  public startConnection = (region:string) => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl('/notify')
      .withAutomaticReconnect()
      .build();

    this.hubConnection.start()
    .then(() =>
      {
        console.log('SignalR connected');
        this.subscribeToRegion(region.trimEnd().toUpperCase());    
      })
    .catch(err => console.log('Error while starting connection:', err));
  }

  subscribeToRegion(region: string){    
    if(this.hubConnection.state === signalR.HubConnectionState.Connected){
      this.hubConnection.invoke('SubscribeToRegion',region.trimEnd().toUpperCase());
    }
    else{
      console.log("Hub not connected");
    }
  }

  unSubscribeToRegion(region: string){
    if(this.hubConnection.state === signalR.HubConnectionState.Connected){
      this.hubConnection.invoke('UnSubscribeToRegion',region.trimEnd().toUpperCase());
    }
    else{
      console.log("Hub not connected");
    }   
  }

  onReceiveUpdate(callback:(data:any)=>void){
    this.hubConnection.on('ReceiveUpdate',callback);
  }

  public addTransferChartDataListener() {
    this.hubConnection.on('notify', (data: NotificationModel) => {
      this.data = data;
      return data;
    });
  }

  public closeConnection = () => {    
    this.hubConnection.stop()
    .then(() => console.log("SignalR disconnected"))
    .catch(err => console.log("Error while stopping connection: ", err));
  };
}
